export default __webpack_public_path__ + "static/media/stretch.7725f6f4.svg";